import React from "react";

import SearchImage from "../images/Search.png";

const VisitCallSummaryCard = ({
  title,
  icon,
  open,
  close,
  not_found,
  total,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  const visitSummary = [
    { status: "Open", count: open },
    { status: "Closed", count: close },
    { status: "Not Found", count: not_found },
    { status: "Total", count: total },
  ];

  if (loading) {
    return (
      <div className="card-section">
        <div className="card-section__header">
          <div className="skeleton skeleton-icon"></div>
          <div className="skeleton skeleton-text skeleton-text--medium"></div>
        </div>
        {[...Array(4)].map((_, index) => (
          <div className="detail-item" key={index}>
            <div className="skeleton skeleton-text skeleton-text--small"></div>
            <div className="skeleton skeleton-text skeleton-text--medium"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section">
        <div className="card-section__header">
          <img src={icon} alt="Visit Icon" />
          <h3 className="card-section__title">{title}</h3>
        </div>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card-section">
      <div className="card-section__header">
        <img src={icon} alt="Dexter Icon" />
        <h3 className="card-section__title">{title}</h3>
      </div>
      {visitSummary.map((item, index) => (
        <div className="detail-item" key={index}>
          <span className="label">{item.status}</span>
          <span className="value text-right-align">
            {!item.count && item.count !== 0 ? "N/A" : item.count}
          </span>
        </div>
      ))}
    </div>
  );
};

export default VisitCallSummaryCard;
